import api from './api';
import { PartnerRegistrationData, Partner, ApiResponse } from '../types';

export const partnerService = {
  async registerPartner(partnerData: PartnerRegistrationData): Promise<ApiResponse<Partner>> {
    const response = await api.post('/user/register', partnerData);
    return response.data;
  },
};
